import NextLink from 'next/link'
import Box from '@mui/material/Box'
import CardMedia from '@mui/material/CardMedia'
import { styled } from '@mui/material/styles'
import Image from '@/components/Image'
import noPreviewImage from '@/assets/img/no-preview.png'
import { getResolvedThumbnailFullServicePath } from '@/helpers/api'

interface ProjectCardThumbnailProps {
  thumbnailUrl: string
  title: string
  href: string
  priority?: boolean
}

const ImageWrapper = styled(Box)(({ theme }) => ({
  display: 'block',
  position: 'relative',
  paddingBottom: '75.005%',
  background: `linear-gradient(180deg, ${theme.palette.grey['50']} 0%, ${theme.palette.grey['150']} 100%)`,
  overflow: 'hidden'
}))

const ImageStyled = styled(Image)({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  maxWidth: '100%',
  height: '100%',
  objectFit: 'cover'
})

export const ProjectCardThumbnail = ({
  thumbnailUrl,
  title,
  href,
  priority
}: ProjectCardThumbnailProps): React.ReactElement => {
  const fullThumbnailUrl = thumbnailUrl ? getResolvedThumbnailFullServicePath(thumbnailUrl) : noPreviewImage
  const thumbnailTitle = `${title} image`

  return (
    <NextLink href={href} passHref legacyBehavior prefetch={false}>
      <CardMedia component="a">
        <ImageWrapper component="span">
          <ImageStyled src={fullThumbnailUrl} alt={thumbnailTitle} width={352} height={264} priority={priority} />
        </ImageWrapper>
      </CardMedia>
    </NextLink>
  )
}
